<!--
Copyright 2022 LINE Fukuoka Corporation

LINE Corporation licenses this file to you under the Apache License,
version 2.0 (the "License"); you may not use this file except in compliance
with the License. You may obtain a copy of the License at:

  https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
License for the specific language governing permissions and limitations
under the License.
-->
<template>
  <div>
    <v-row align="center" justify="center">
      <v-btn type="submit" depressed block color="primary">{{
        this.title
      }}</v-btn>
    </v-row>
  </div>
</template>

<script>
import Vue from "vue";
import InputBase from "./InputBase.vue";
export default Vue.extend({
  name: "InputLinkButton",
  mixins: [InputBase],
  methods: {
    // getValue: function () {
    //   return this.input;
    // },
    // link_action: function () {
    //   const requestOptions = {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json" },
    //     body: JSON.stringify({
    //       title: "POST Request test",
    //       // SurveyId: GetSurveyById,
    //     }),
    //   };
    //   fetch("https://jsonplaceholder.typicode.com/posts", requestOptions)
    //     .then((response) => response.json())
    //     .then((data) => console.log(data));
    //   // window.open(this.params.input);
    //   return;
    // },
  },
});
</script>

<style scoped>
* {
  text-transform: none !important;
}
.v-btn {
  max-width: 100%;
}
</style>
